import { ChangeEvent, useState } from "react";
import "./DatePicker.css";
import { TransformedEvent } from "../../Utils/ParsingUtil";
import {
  CheckboxList,
  filterByDateRange,
  filterByTopic,
} from "../Checkbox/CheckBox";
import { createMultipleMeetings } from "../OutlookMeeting/OutlookMeeting";
import Popup from "../Popup/Popup";
import { useCallbackState } from "../../Utils/GlobalContext";
const POPUP_TITLE =
  "Termine aus gewähltem Zeitraum in Outlook übernehmen";

interface DateRangePickerProps {
  closePopup: () => void;
}

const DateRangePicker = ({ closePopup }: DateRangePickerProps) => {
  const [startDate, setStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [endDate, setEndDate] = useState(new Date().getFullYear() + "-12-31");
  const { appointments, checkBoxOutlook, setCheckBoxOutlook } =
    useCallbackState();

  const handleDownloadButtonClick = () => {
    const filterByDate: TransformedEvent[] = filterByDateRange(
      appointments,
      new Date(startDate),
      new Date(endDate)
    );
    const filteredByTopic: TransformedEvent[] = filterByTopic(
      filterByDate,
      checkBoxOutlook
    );
    createMultipleMeetings(filteredByTopic);
    closePopup();
    document.removeEventListener("keydown", handleEscapeKey);
  };

  const handleEscapeKey = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      closePopup();
      document.removeEventListener("keydown", handleEscapeKey);
    }
  };
  const handleStartDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    setStartDate(event.target.value);
  };
  const handleEndDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEndDate(event.target.value);
  };
  let timeRange = true;
  let disableButton = false;
  if (checkBoxOutlook.length < 1 || endDate < startDate) {
    disableButton = true;
  } else {
    disableButton = false;
  }
  if (endDate < startDate) {
    timeRange = false;
  }

  return (
    <Popup
      close={closePopup}
      handleButtonClick={handleDownloadButtonClick}
      popupTitle={POPUP_TITLE}
      disabled={disableButton}
    >
      <div>
        <div className="popup-content">
          <div className="date-range-popup">
            <div className="date-inputs">
              <label className="date-label">
                <b>Von</b>
              </label>
              <input
                type="date"
                value={startDate}
                onChange={handleStartDateChange}
                className={`date-input ${timeRange ? "" : "input-red"}`}
              />
            </div>
            <div className="date-inputs">
              <label className="date-label">
                <b>Bis</b>
              </label>
              <input
                type="date"
                value={endDate}
                onChange={handleEndDateChange}
                className={`date-input ${timeRange ? "" : "input-red"}`}
              />
            </div>
          </div>
          <CheckboxList
            checkedAppointment={checkBoxOutlook}
            setCheckedAppointment={setCheckBoxOutlook}
          />
        </div>
      </div>
    </Popup>
  );
};

export default DateRangePicker;
